import React, { Component } from "react";
import axios from "axios";
import Member from "./Member";
import CSS from "./TeamMembers.module.css";

class TeamMember extends Component {
  constructor() {
    super();
    this.state = {
      members: [],
      showMore: false, // Show more logic preserved
    };
  }

  componentDidMount() {
    axios
      .get(
        "https://recstudentportal.com/api/v1/getTeamMemberDetails.php?key=cmVhY3RBcHBQb3J0YWwyNjc="
      )
      .then((data) => {
        this.setState({ members: data.data });
      });
  }

  render() {
    const visibleMembers = this.state.showMore
      ? this.state.members // Show all
      : this.state.members.slice(0, 9); // Show first 9

    return (
      <div style={{ textAlign: "center", background: "#121c79" }}>
        <div className={CSS.TeamMember}>
          {visibleMembers.map((member) => (
            <Member key={member.regid} {...member} />
          ))}
        </div>

        {this.state.members.length > 9 && (
          <button
            onClick={() =>
              this.setState({ showMore: !this.state.showMore })
            }
            style={{
              background: "#fff",
              color: "#121c79",
              padding: "10px 25px",
              fontSize: "16px",
              borderRadius: "6px",
              border: "none",
              margin: "25px 0",
              cursor: "pointer",
              fontWeight: "600",
              boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
            }}
          >
            {this.state.showMore ? "Show Less" : "Show More"}
          </button>
        )}
      </div>
    );
  }
}

export default TeamMember;
